import api from "./api";

export const REPORT_BUG_URL = "/api/_internal/customer/report-bug";

export type Severity = "annoying" | "somewhat_blocked" | "completely_blocked";
export type Reproducibility = "always" | "sometimes";

export interface BugReportPayload {
  description: string;
  reproducibility: Reproducibility;
  steps_to_reproduce: string;
  document_examples: string;
  severity: Severity;
  screenshot?: File | null;
}

export async function reportBug(
  token: string,
  payload: BugReportPayload
): Promise<string> {
  const formData = new FormData();
  formData.append("description", payload.description);
  formData.append("reproducibility", payload.reproducibility);
  formData.append("steps_to_reproduce", payload.steps_to_reproduce);
  formData.append("document_examples", payload.document_examples);
  formData.append("severity", payload.severity);
  if (payload.screenshot) {
    formData.append("screenshot", payload.screenshot, payload.screenshot.name);
  }
  const response = await api.post<string>(REPORT_BUG_URL, formData, {
    headers: { token, "Content-Type": "multipart/form-data" },
  });
  return response.data;
}
